import { FlowsProvider } from "@flows/react";
import * as components from "@flows/react-components";
import * as surveyComponents from "@flows/react-components/survey";
import * as tourComponents from "@flows/react-components/tour";
import { useUserStore } from "stores/userStore";

import "@flows/react-components/index.css";
import PageBanner from "./components/pageBanner";
import { useMemo } from "react";

interface UserFlowProps {
  children?: React.ReactNode;
}

export default function UserFlow(props: Readonly<UserFlowProps>) {
  const { children } = props;
  const userId = useUserStore((state) => state.userId);
  const portfolioId = useUserStore((state) => state.portfolioId);
  const tenantId = useUserStore((state) => state.tenantId);
  const portfolioRole = useUserStore((state) => state.portfolioRole);
  const tenantRole = useUserStore((state) => state.tenantRole);

  const userProperties = useMemo(
    () => ({
      domain: globalThis.location.host,
      portfolioId: portfolioId,
      tenantId: tenantId,
      portfolioRole: portfolioRole,
      tenantRole: tenantRole,
    }),
    [portfolioId, tenantId, portfolioRole, tenantRole],
  );

  if (userId == null) {
    return children;
  }

  return (
    <FlowsProvider
      organizationId={import.meta.env.VITE_FLOWS_ORGANIZATION_ID}
      environment={import.meta.env.VITE_FLOWS_ENVIRONMENT}
      userId={userId}
      userProperties={userProperties}
      components={{
        ...components,
        PageBanner: PageBanner,
      }}
      tourComponents={{ ...tourComponents }}
      surveyComponents={{ ...surveyComponents }}
    >
      {children}
    </FlowsProvider>
  );
}
